import type { TreeNodeData } from "../../Tree/types";

export const pruneTree = (
  nodes: TreeNodeData[],
  searchTerm: string
): TreeNodeData[] => {
  if (!searchTerm.trim()) return nodes;

  const lower = searchTerm.toLowerCase();

  const prune = (items: TreeNodeData[]): TreeNodeData[] =>
    items.reduce<TreeNodeData[]>((acc, node) => {
      const titleStr = typeof node.title === "string" ? node.title : "";
      const nodeMatches = titleStr.toLowerCase().includes(lower);

      if (nodeMatches) {
        acc.push(node);
      } else {
        const prunedChildren = node.children ? prune(node.children) : [];
        if (prunedChildren.length > 0) {
          acc.push({ ...node, children: prunedChildren });
        }
      }

      return acc;
    }, []);

  return prune(nodes);
};
